import {Loadable} from './Loadable.type';

export class Loader {
  private _queue: Loadable[] = [];

  clear() {
    this._queue = [];
  }

  insertLoadable(...loadables: Loadable[]) {
    this._queue.unshift(...loadables);
  }

  appendLoadable(...loadables: Loadable[]) {
    this._queue.push(...loadables);
  }

  async *loadGenerator() {
    while (true) {
      const loadable = this._queue.shift();
      if (!loadable) {
        break;
      }
      await loadable.load();
      yield loadable;
    }
  }
}
